import DOMPurify from "dompurify";

// Legacy CDP links opened a popup through onclick, which sanitizing strips; open them in a new tab.
DOMPurify.addHook("afterSanitizeAttributes", node => {
  if (
    node.tagName === "A" &&
    !node.hasAttribute("target") &&
    /^https?:/i.test(node.getAttribute("href") ?? "")
  ) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener");
  }
});

// Components re-render on every playback tick; parse each description once.
const cache = new Map<string, string>();
const CACHE_LIMIT = 500;

/** Strips scripts and event handlers from CDP HTML; keeps link `target` that descriptions use. */
export function sanitizeHtml(html: string): string {
  let clean = cache.get(html);
  if (clean === undefined) {
    clean = DOMPurify.sanitize(html, { ADD_ATTR: ["target"] });
    if (cache.size >= CACHE_LIMIT) {
      cache.clear();
    }
    cache.set(html, clean);
  }
  return clean;
}
